import { CISO_CIRA_API } from '@/api';
import config from './ciraReportConfig';

const state = {
  tableData: [],
  rsiTableData: [],
  rsiTableConfig: config.rsiFields,
  tableConfig: config.fields,
  parameters: [],
};

const actions = {
  async fetchCIRAReport({ commit, state }, { params }) {
    commit('setParameters', params);
    commit('setTableData', []);
    commit('setRsiTableData', []);
    state.params = params;

    try {
      const { data } = await CISO_CIRA_API.get('/cirareport', { params });
      if (params.raVer) {
        commit('setRsiTableData', data);
      } else {
        commit('setTableData', data);
      }
    } catch (err) {
      if (err.response || err.message) {
        console.log(err);
      }
      this.$notify('Failed to Load CIRA Report', 'error');
    }
  },
  reset({ commit }) {
    commit('setTableData', []);
    commit('setRsiTableData', []);
  },
};

const mutations = {
  setTableData(state, data) {
    state.tableData = Object.freeze(data);
  },
  setRsiTableData(state, data) {
    state.rsiTableData = Object.freeze(data);
  },
  setParameters(state, params) {
    state.parameters = params;
  },
  setTableConfig(state, value) {
    state.tableConfig = value;
  },
  setRsiTableConfig(state, value) {
    state.rsiTableConfig = value;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};